import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import ReduxThunk from "redux-thunk";
import authReducer from "./reducers/authReducer";
import contentReducer from "./reducers/contentReducer";
import mainReducer from "./reducers/mainReducer";
import modalReducer from "./reducers/modalReducer";
import usersReducer from "./reducers/usersReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  content: contentReducer,
  main: mainReducer,
  users: usersReducer,
});

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(ReduxThunk),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (f) => f
  )
);

export default store;
